import { ActiveOrder, ScreenContext } from './types';

const ORDER_PATH = /^\/orders\/details\/([^/]+)/;

/**
 * The URL is the source of truth: the stored active order is only reported while the browser
 * is on that same order's route, so a stale or other open order can never leak.
 */
export const resolveActiveOrder = (pathname: string, activeOrder: ActiveOrder): ActiveOrder => {
  const match = pathname.match(ORDER_PATH);
  if (!activeOrder || !match) return null;
  return match[1] === activeOrder.internalId ? activeOrder : null;
};

const describeOrder = (order: NonNullable<ActiveOrder>): string => {
  const details = [
    `internal id: ${order.internalId}`,
    order.orderType ? `type: ${order.orderType}` : '',
    order.transactionType ? `transaction: ${order.transactionType}` : '',
  ].filter(Boolean).join(', ');
  return `${order.orderNumber} (${details})`;
};

export const serializeHeader = (ctx: ScreenContext): string => {
  const order = resolveActiveOrder(ctx.pathname, ctx.activeOrder);
  return [
    `- Screen: ${ctx.screenLabel}`,
    `- URL path: ${ctx.pathname}`,
    `- Active order: ${order ? describeOrder(order) : 'none'}`,
    '- Note: other open orders and navigation chrome are intentionally omitted.',
  ].join('\n');
};
